export enum UserTypeEnum {
    BROKER = 'BROKER',
    LISTER = 'LISTER',
}
